import React from "react";

const ModernPdfIcon = () => {
  return (
    <svg
      width="58"
      height="56"
      viewBox="0 0 58 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.9529 54.5H21.6738C18.084 54.5 15.1738 51.5899 15.1738 48V8C15.1738 4.41015 18.084 1.5 21.6738 1.5H38.7734L56.4529 19.1795V48C56.4529 51.5899 53.5427 54.5 49.9529 54.5Z"
        fill="#EEF1F7"
        stroke="#CBD0DC"
        stroke-width="3"
      />
      <rect
        y="21.7461"
        width="39.0698"
        height="22.7907"
        rx="6.59049"
        fill="#D82042"
      />
      <path
        d="M6.47559 38.6734V27.7812H10.3581C11.2055 27.7812 11.9075 27.9355 12.4642 28.244C13.0208 28.5524 13.4374 28.9744 13.714 29.5097C13.9906 30.0416 14.1288 30.6408 14.1288 31.3074C14.1288 31.9775 13.9888 32.5803 13.7087 33.1157C13.4321 33.6475 13.0137 34.0694 12.4535 34.3814C11.8969 34.6899 11.1966 34.8441 10.3527 34.8441H7.68287V33.4507H10.2038C10.7392 33.4507 11.1735 33.3585 11.5068 33.1742C11.8401 32.9862 12.0848 32.731 12.2408 32.4083C12.3968 32.0856 12.4748 31.7187 12.4748 31.3074C12.4748 30.8961 12.3968 30.5309 12.2408 30.2118C12.0848 29.8927 11.8384 29.6427 11.5015 29.4619C11.1682 29.2811 10.7286 29.1906 10.1825 29.1906H8.11899V38.6734H6.47559Z"
        fill="white"
      />
      <path
        d="M19.5816 38.6734H16.0554V27.7812H19.6933C20.7605 27.7812 21.677 27.9993 22.4429 28.4354C23.2087 28.868 23.7955 29.4902 24.2033 30.3022C24.6146 31.1106 24.8202 32.0803 24.8202 33.2114C24.8202 34.346 24.6128 35.321 24.198 36.1365C23.7867 36.952 23.191 37.5796 22.411 38.0193C21.6309 38.4554 20.6878 38.6734 19.5816 38.6734ZM17.6988 37.2374H19.4912C20.3208 37.2374 21.0105 37.0814 21.56 36.7694C22.1096 36.4539 22.5209 35.9983 22.7939 35.4026C23.0669 34.8034 23.2034 34.073 23.2034 33.2114C23.2034 32.3569 23.0669 31.6318 22.7939 31.0361C22.5244 30.4405 22.122 29.9884 21.5866 29.6799C21.0512 29.3715 20.3864 29.2172 19.5922 29.2172H17.6988V37.2374Z"
        fill="white"
      />
      <path
        d="M26.8638 38.6734V27.7812H33.6183V29.196H28.5072V32.5147H33.1343V33.9241H28.5072V38.6734H26.8638Z"
        fill="white"
      />
    </svg>
  );
};

export default ModernPdfIcon;
